<script setup lang="ts">
import { computed } from 'vue'

import { useAd } from '../../../advertisement/composables/use-ad'

const props = defineProps<{
  index: number
}>()

const index = computed(() => props.index)
const { slotName, status, minWidth, minHeight } = useAd('outstream', index.value)
</script>

<template>
  <div :style="{ minWidth: minWidth ?? undefined, minHeight: minHeight ?? undefined }">
    <div v-if="slotName && status !== 'failed'"
         :id="slotName"
         class="w-full min-h-32 bg-aside py-4" />
  </div>
</template>
